<script>
    export let event;

    let url = false;
    if (event.video_url) {
        url = event.video_url.replace('youtube.com', 'youtube-nocookie.com');
    }
</script>
{#if url}
    <div class="embed-responsive embed-responsive-16by9">
        <iframe width="560" height="315" src="{url}" frameborder="0"
                allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
                title="Video of event: {event.name}"
                allowfullscreen></iframe>
    </div>
{/if}